export const BookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M18.3383 5.00098V14.1676C18.3383 14.6097 18.1627 15.0336 17.8501 15.3462C17.5376 15.6587 17.1136 15.8343 16.6716 15.8343C15.2799 15.8343 12.5549 15.8343 11.3633 16.6676H18.3383C18.5593 16.6676 18.7713 16.5798 18.9275 16.4236C19.0838 16.2673 19.1716 16.0553 19.1716 15.8343V5.83431C19.1716 5.6133 19.0838 5.40133 18.9275 5.24505C18.7713 5.08877 18.5593 5.00098 18.3383 5.00098Z"
      fill="white"
    />
    <path
      d="M1.66927 14.1676V5.00098C1.44826 5.00098 1.2363 5.08877 1.08002 5.24505C0.923735 5.40133 0.835938 5.6133 0.835938 5.83431V15.8343C0.835938 16.0553 0.923735 16.2673 1.08002 16.4236C1.2363 16.5798 1.44826 16.6676 1.66927 16.6676H8.64427C7.46094 15.8343 4.7276 15.8343 3.33594 15.8343C2.89391 15.8343 2.46999 15.6587 2.15743 15.3462C1.84487 15.0336 1.66927 14.6097 1.66927 14.1676Z"
      fill="white"
    />
    <path
      d="M3.33724 3.33398C3.11623 3.33398 2.90426 3.42178 2.74798 3.57806C2.5917 3.73434 2.50391 3.9463 2.50391 4.16732V14.1673C2.50391 14.3883 2.5917 14.6003 2.74798 14.7566C2.90426 14.9129 3.11623 15.0007 3.33724 15.0007C5.79974 15.0007 8.49974 15.1257 9.58724 16.4048V4.46732C8.09974 3.44648 5.62057 3.33398 3.33724 3.33398Z"
      fill="white"
    />
    <path
      d="M17.5013 14.1673V4.16732C17.5013 3.9463 17.4135 3.73434 17.2572 3.57806C17.1009 3.42178 16.889 3.33398 16.668 3.33398C14.3846 3.33398 11.9055 3.44648 10.418 4.46732V16.4048C11.5055 15.1257 14.2055 15.0007 16.668 15.0007C16.889 15.0007 17.1009 14.9129 17.2572 14.7566C17.4135 14.6003 17.5013 14.3883 17.5013 14.1673Z"
      fill="white"
    />
  </svg>
);
